import { Col, Form, FormProps, Row } from "antd";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "../CustomButton";
import styles from "./style.module.scss";
import "./style.scss";

const CustomTableForm = (
  props: FormProps & { formItemList: any[]; isSearchLoading: boolean }
) => {
  const { t } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });
  return (
    <div className={styles.container}>
      <Form {...props} layout="vertical" className="custom-table-form">
        <Row gutter={16}>
          {props.formItemList?.map((formItem, index) => (
            <Col span={windowWidth >= 768 ? 12 : 24} key={"forItem" + index}>
              {formItem}
            </Col>
          ))}
        </Row>
        <div className={styles.submitBtnContainer}>
          <CustomButton
            type="primary"
            htmlType="submit"
            loading={props.isSearchLoading}
            block={windowWidth > 768 ? false : true}
          >
            {t("normal.search")}
          </CustomButton>
        </div>
      </Form>
    </div>
  );
};

export default CustomTableForm;
